var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPremiumPackageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_305_51662)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.3 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.42871 17V7H12.0287C12.8287 7 13.4906 7.1381 14.0144 7.41429C14.5382 7.68095 14.9287 8.04286 15.1859 8.5C15.443 8.95714 15.5716 9.48095 15.5716 10.0714C15.5716 10.6238 15.4478 11.1333 15.2001 11.6C14.9525 12.0571 14.5668 12.4286 14.043 12.7143C13.5192 12.9905 12.8478 13.1286 12.0287 13.1286H10.143V17H8.42871ZM10.143 11.7286H11.9287C12.6049 11.7286 13.0906 11.581 13.3859 11.2857C13.6811 10.981 13.8287 10.5762 13.8287 10.0714C13.8287 9.54762 13.6811 9.1381 13.3859 8.84286C13.0906 8.54762 12.6049 8.4 11.9287 8.4H10.143V11.7286Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_305_51662",
    x1: 18.3156,
    y1: 4.26319,
    x2: 2.90956,
    y2: 27.2422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F4CC7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumPackageIcon);
export default __webpack_public_path__ + "static/media/premiumPackageIcon.695b6dd40a8071442932f4085383efe6.svg";
export { ForwardRef as ReactComponent };